export const STATUS_PARAM_NAME = 'status';

export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const JOB_EXPIRED = 'JOB_EXPIRED';
